import React, { Component } from 'react'
import 'Styles/commonComponents.scss'

export default class LoadingIndicator extends Component {

    constructor() {
        super();

        this.state = {
            class: ''
        }

        this.componentMounted = false;
        this.run = false;
    }

    componentDidMount(){
        this.componentMounted = true;
        if (this.props.runner && this.run === false)
            this.StartRunning();
    }

    componentWillUnmount() {
        this.run = false;
        this.componentMounted = false;
    }

    Run() {
        if (this.run === false) return;

        this.setState({class: 'run'})
        setTimeout(_=> {
            if (this.componentMounted)
                this.setState({class: 'restore-default'});
            setTimeout(_=> {
                if (this.componentMounted)
                    this.setState({class: ''});
                setTimeout(_=> { 
                    this.Run();
                }, 1000);
            }, 500);
        }, 1500);
    }

    StartRunning() {
        this.run = true;
        
        this.Run();
    }

    render() {
        if (this.props.runner) {
            return (
                <div className={'loading-indicator runner ' + (this.props.className == null ? '' : this.props.className)}>
                    <div className="initial-value">
                        <div className={ "loaded-value-runner " + this.state.class } />
                    </div>
                </div>
            )
        }
        
        let loadedPercents = this.props.loaded * 100 / this.props.total;
        
        return (
            <div className={'loading-indicator ' + (this.props.className == null ? '' : this.props.className)}>
                <div className="initial-value">
                </div>
                <div className="loaded-value-container" 
                     style={ { width: `${loadedPercents}%` } }>
                    <div></div>
                </div>
            </div>
        )
    }
}